import { parseFormulaArguments } from "./parseFormulaArguments";

export const getFormulaDependencyIds = (formula: string): string[] =>
  Array.from(
    new Set(
      parseFormulaArguments(formula).map(
        ({ linkId, attributeId }) => linkId ?? attributeId,
      ),
    ),
  );
